import { useEffect } from "react";
import { useMenu } from "../utils/BurgerMenuContexte.tsx";
import gsap from "gsap";

function PagerMover() {
  const { isBurgerMenuOpened } = useMenu();
  useEffect(() => {
    // Ciblez les éléments à animer. Adaptez le sélecteur à vos besoins.
    const targets = document.querySelectorAll(".page-content");

    if (isBurgerMenuOpened) {
      // Déplacer les éléments vers la gauche (-100%)
      gsap.to(targets, {
        xPercent: -100,
        duration: 0.5,
        ease: "power1.out",
        stagger: 0.1,
        opacity: 0,
      });
    } else {
      // Remettre les éléments en position initiale
      gsap.to(targets, {
        delay: 0.5,
        xPercent: 0,
        duration: 0.5,
        ease: "power1.in",
        stagger: 0.1,
        opacity: 1,
      });
    }
  }, [isBurgerMenuOpened]);

  return null;
}

export default PagerMover;
